/** Toast — a short message at the top of the screen that clears itself. */

import React, { useEffect } from 'react';

export default function Toast({ toast, onDone, ms = 2600 }) {
  useEffect(() => {
    if (!toast) return undefined;
    const t = setTimeout(onDone, ms);
    return () => clearTimeout(t);
  }, [toast, onDone, ms]);
  if (!toast) return null;
  return (
    <div className={`ax-toast ${toast.type ? `ax-toast--${toast.type}` : ''}`} role="status" aria-live="polite">
      {toast.text}
    </div>
  );
}
